export default "__VITE_ASSET__DZfA2p2c__"